import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.support.manage');
import { OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

declare const wiz: any;
declare const WizRoute: any;

@Component({
    selector: 'wiz-page-support-manage',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.support.manage/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageSupportManageComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  public router: Router) { }

    public application_id: string = '';
    public menu: string = 'overview';
    public loaded: boolean = false;

    public application: any = null;
    public company: any = null;
    public program: any = null;
    public myApplications: any[] = [];
    public supportGroup: string = 'ongoing';
    public supportGroups = [
        { key: 'ongoing', label: '참여중인 지원사업' },
        { key: 'completed', label: '종료 지원사업' },
    ];

    public modules: any[] = [];
    public attendances: any[] = [];
    public submissions: any[] = [];
    public feedbacks: any[] = [];
    public performances: any[] = [];

    // 신규 탭: 공지/일정/평가결과
    public posts: any[] = [];
    public postsTotal: number = 0;
    public postsPage: number = 1;
    public selectedPost: any = null;
    public milestones: any[] = [];
    public selectedMilestone: any = null;
    public myEvaluations: any[] = [];
    public evalCriteria: any[] = [];
    public evalSummary: any = null;

    public showSubmit: boolean = false;
    public submitForm: any = { module_id: '', session_id: '', submission_type: 'homework', title: '', content: '' };

    public showPerf: boolean = false;
    public perfForm: any = { report_period: '', revenue: 0, investment_raised: 0, new_hires: 0, new_patents: 0, awards: '', narrative: '' };

    // 기업정보 편집
    public editingCompany: boolean = false;
    public companyForm: any = {};
    public uploadingLicense: boolean = false;

    // 알림 / 캘린더
    public alerts: any[] = [];
    public unreadCount: number = 0;
    public alertsLastSeen: number = 0;
    public calendarMonth: Date = new Date();
    public calendarCells: any[] = [];
    public selectedCalendarDate: string = '';

    public menus = [
        { key: 'overview', label: '개요', icon: '🏠' },
        { key: 'company', label: '기업정보', icon: '🏢' },
        { key: 'notices', label: '공지사항', icon: '📢' },
        { key: 'schedule', label: '일정', icon: '📅' },
        { key: 'modules', label: '프로그램', icon: '📚' },
        { key: 'sessions', label: '회차/출석', icon: '🗓️' },
        { key: 'feedback', label: '피드백', icon: '💬' },
        { key: 'performance', label: '성과 보고', icon: '📊' },
        { key: 'alerts', label: '알림', icon: '🔔' },
    ];

    private routerSub: any;

    public async ngOnInit() {
        await this.service.init();
        await this.loadMyList();
        await this.parseRoute();
        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) await this.parseRoute();
        });
    }

    public ngOnDestroy() { if (this.routerSub) this.routerSub.unsubscribe(); }

    public async parseRoute() {
        const first = WizRoute.segment.application_id || '';
        if (!first) {
            this.service.href('/support/manage/ongoing');
            return;
        }
        if (this.isSupportGroup(first)) {
            this.supportGroup = first;
            this.clearDetail();
            this.menu = 'overview';
            this.loaded = true;
            await this.service.render();
            return;
        }

        const aid = first;
        const menu = WizRoute.segment.menu || 'overview';
        if (aid !== this.application_id) {
            this.application_id = aid;
            await this.reload();
        }
        if (this.application) this.supportGroup = this.groupForApplication(this.application);
        if (menu !== this.menu) {
            this.menu = menu;
            await this.loadTab();
        }
        await this.service.render();
    }

    public async loadMyList() {
        const r = await wiz.call('list_my_applications', {});
        if (r.code == 200) this.myApplications = r.data.rows || [];
    }

    public async reload() {
        if (!this.application_id) {
            this.clearDetail();
            this.loaded = true;
            return;
        }
        this.loaded = false;
        await this.service.render();
        const r = await wiz.call('get', { application_id: this.application_id });
        if (r.code != 200) {
            this.service.alert.show({ title: '오류', message: r.data?.message || '권한이 없거나 신청 정보를 찾을 수 없습니다.', action: '확인' });
            this.application = null;
            this.company = null;
            this.program = null;
            this.loaded = true;
            return;
        }
        this.application = r.data.data?.application;
        this.company = r.data.data?.company;
        this.program = r.data.data?.program;
        if (this.application) this.supportGroup = this.groupForApplication(this.application);
        this.loaded = true;
        await this.refreshUnreadBadge();
        await this.loadTab();
    }

    public async loadTab() {
        if (!this.application_id) return;
        if (this.menu === 'modules') {
            const r = await wiz.call('list_modules', { application_id: this.application_id });
            if (r.code == 200) this.modules = r.data.rows || [];
        } else if (this.menu === 'sessions') {
            const r = await wiz.call('list_attendances', { application_id: this.application_id });
            if (r.code == 200) this.attendances = r.data.rows || [];
        } else if (this.menu === 'submissions') {
            const r = await wiz.call('list_submissions', { application_id: this.application_id });
            if (r.code == 200) this.submissions = r.data.rows || [];
            const r2 = await wiz.call('list_modules', { application_id: this.application_id });
            if (r2.code == 200) this.modules = r2.data.rows || [];
        } else if (this.menu === 'feedback') {
            const r = await wiz.call('list_feedbacks', { application_id: this.application_id });
            if (r.code == 200) this.feedbacks = r.data.rows || [];
        } else if (this.menu === 'performance') {
            const r = await wiz.call('list_performances', { application_id: this.application_id });
            if (r.code == 200) this.performances = r.data.rows || [];
        } else if (this.menu === 'notices') {
            const r = await wiz.call('list_program_posts', { application_id: this.application_id, page: this.postsPage, dump: 30 });
            if (r.code == 200) {
                this.posts = r.data.rows || [];
                this.postsTotal = r.data.total || 0;
            }
        } else if (this.menu === 'schedule') {
            const r = await wiz.call('list_program_milestones', { application_id: this.application_id });
            if (r.code == 200) this.milestones = r.data.rows || [];
            // 일정에서 참조할 모듈명 매핑을 위해 모듈 목록도 로드
            try {
                const rm = await wiz.call('list_modules', { application_id: this.application_id });
                if (rm.code == 200) this.modules = rm.data.rows || [];
            } catch (e) { }
            this.buildCalendar();
        } else if (this.menu === 'alerts') {
            const r = await wiz.call('list_alerts', { application_id: this.application_id });
            if (r.code == 200) this.alerts = r.data.rows || [];
            // 탭 진입 시 모두 읽음 처리
            this.markAlertsSeen();
        } else if (this.menu === 'evaluation') {
            const r = await wiz.call('list_my_evaluations', { application_id: this.application_id });
            if (r.code == 200) {
                this.myEvaluations = r.data.rows || [];
                this.evalCriteria = r.data.criteria || [];
                this.evalSummary = r.data.application || null;
            }
        }
        await this.service.render();
    }

    public async openPost(p: any) {
        try {
            const r = await wiz.call('get_program_post', { application_id: this.application_id, post_id: p.id });
            if (r.code == 200) this.selectedPost = r.data.data;
        } catch (e) { }
        await this.service.render();
    }
    public closePost() { this.selectedPost = null; }

    // ===== Milestone (사업 일정) detail =====
    public openMilestone(m: any) {
        this.selectedMilestone = m;
    }
    public closeMilestone() { this.selectedMilestone = null; }

    public msTypeLabel(t: string): string {
        const m: any = {
            event: '이벤트', mentoring: '멘토링', education: '교육',
            workshop: '워크숍', networking: '네트워킹', site_visit: '현장방문',
            ir_pitching: 'IR 피칭', demoday: '데모데이', kickoff: '킥오프',
            survey: '설문', diagnosis: '진단', expense_mgmt: '예산집행',
            funding_match: '투자매칭', follow_up: '사후관리', reporting: '보고',
            company_mgmt: '기업관리', recruitment: '모집', selection: '선발',
            midcheck: '중간점검', final: '최종', settlement: '정산',
        };
        return m[t] || t || '이벤트';
    }

    public msStatusLabel(s: string): string {
        const m: any = { planned: '예정', ongoing: '진행중', in_progress: '진행중', done: '완료', canceled: '취소' };
        return m[s] || s || '예정';
    }

    public msTypes(m: any): string[] {
        const arr = m?.extra?.types;
        if (Array.isArray(arr) && arr.length) return arr;
        return m?.type ? [m.type] : ['event'];
    }

    public msTimeLabel(m: any): string {
        const ex = m?.extra || {};
        if (ex.time_tbd) return '시간 추후 안내 예정';
        const s = ex.start_time || '';
        const e = ex.end_time || '';
        if (s && e) return `${s} ~ ${e}`;
        return s || e || '';
    }

    public msLocationLabel(m: any): string {
        if (m?.extra?.location_tbd) return '장소 추후 안내 예정';
        return m?.location || '';
    }

    public msModuleNames(m: any): string[] {
        const ids: string[] = (m?.extra?.module_ids || []) as string[];
        if (!ids || ids.length === 0) return [];
        return ids.map((id: string) => {
            const mod = (this.modules || []).find((x: any) => x.id === id);
            return mod ? (mod.title || mod.module_type || id) : id;
        });
    }

    // ===== Calendar (월간) =====
    private _seenKey(): string { return `support_manage_alerts_seen_${this.application_id}`; }

    public async refreshUnreadBadge() {
        try {
            const ts = parseInt(localStorage.getItem(this._seenKey()) || '0', 10) || 0;
            this.alertsLastSeen = ts;
            const r = await wiz.call('list_alerts', { application_id: this.application_id });
            if (r.code == 200) {
                const rows = r.data.rows || [];
                this.unreadCount = rows.filter((x: any) => this._toTs(x.created) > ts).length;
            }
        } catch (e) { this.unreadCount = 0; }
        await this.service.render();
    }

    public markAlertsSeen() {
        const now = Date.now();
        try { localStorage.setItem(this._seenKey(), String(now)); } catch (e) { }
        this.alertsLastSeen = now;
        this.unreadCount = 0;
    }

    private _toTs(s: string): number {
        if (!s) return 0;
        const t = Date.parse(String(s).replace(' ', 'T'));
        return isNaN(t) ? 0 : t;
    }

    public isAlertUnread(a: any): boolean {
        return this._toTs(a?.created) > this.alertsLastSeen;
    }

    public alertIcon(k: string): string {
        return k === 'post' ? '📢' : (k === 'feedback' ? '💬' : (k === 'milestone' ? '📅' : '🔔'));
    }

    public alertKindLabel(k: string): string {
        return k === 'post' ? '공지' : (k === 'feedback' ? '피드백' : (k === 'milestone' ? '일정' : '알림'));
    }

    public openAlert(a: any) {
        if (a?.menu) this.selectMenu(a.menu);
    }

    public buildCalendar() {
        const y = this.calendarMonth.getFullYear();
        const m = this.calendarMonth.getMonth();
        const first = new Date(y, m, 1);
        const startDow = first.getDay();
        const daysInMonth = new Date(y, m + 1, 0).getDate();
        const cells: any[] = [];
        // 이전달 빈칸
        for (let i = 0; i < startDow; i++) cells.push({ blank: true });
        const todayStr = this._dateStr(new Date());
        for (let d = 1; d <= daysInMonth; d++) {
            const dateStr = `${y}-${String(m + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
            const events = (this.milestones || []).filter((x: any) => (x.start_date || '').slice(0, 10) === dateStr);
            cells.push({ date: dateStr, day: d, events, today: dateStr === todayStr });
        }
        // 6주 그리드 채움
        while (cells.length % 7 !== 0) cells.push({ blank: true });
        this.calendarCells = cells;
    }

    private _dateStr(d: Date): string {
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    }

    public calendarLabel(): string {
        return `${this.calendarMonth.getFullYear()}년 ${this.calendarMonth.getMonth() + 1}월`;
    }

    public prevMonth() {
        this.calendarMonth = new Date(this.calendarMonth.getFullYear(), this.calendarMonth.getMonth() - 1, 1);
        this.buildCalendar();
    }
    public nextMonth() {
        this.calendarMonth = new Date(this.calendarMonth.getFullYear(), this.calendarMonth.getMonth() + 1, 1);
        this.buildCalendar();
    }
    public goToday() {
        this.calendarMonth = new Date();
        this.selectedCalendarDate = '';
        this.buildCalendar();
    }
    public clickCalendarDay(c: any) {
        if (!c || c.blank) return;
        if (c.events && c.events.length === 1) {
            this.openMilestone(c.events[0]);
            return;
        }
        this.selectedCalendarDate = (this.selectedCalendarDate === c.date) ? '' : c.date;
    }
    public visibleMilestones(): any[] {
        if (this.selectedCalendarDate) {
            return (this.milestones || []).filter((m: any) => (m.start_date || '').slice(0, 10) === this.selectedCalendarDate);
        }
        // 기본: 이번 달
        const y = this.calendarMonth.getFullYear();
        const mo = this.calendarMonth.getMonth();
        return (this.milestones || []).filter((m: any) => {
            const d = (m.start_date || '').slice(0, 10);
            if (!d) return false;
            const dt = new Date(d);
            return dt.getFullYear() === y && dt.getMonth() === mo;
        });
    }

    public stageLabel(s: string): string {
        return s === 'doc' ? '서류' : (s === 'pt' ? '발표' : (s === 'field' ? '현장' : (s || '-')));
    }

    public statusBadge(s: string): string {
        const m: any = {
            'submitted': '접수', 'screening': '서류심사중',
            'doc_passed': '서류합격', 'doc_failed': '서류탈락',
            'pt_passed': '발표합격', 'pt_failed': '발표탈락',
            'selected': '선정', 'rejected': '불선정', 'withdrawn': '철회'
        };
        return m[s] || s || '-';
    }

    public statusColor(s: string): string {
        if (['selected','doc_passed','pt_passed'].includes(s)) return 'bg-emerald-50 text-emerald-700';
        if (['rejected','doc_failed','pt_failed','withdrawn'].includes(s)) return 'bg-red-50 text-red-700';
        if (['submitted','screening'].includes(s)) return 'bg-amber-50 text-amber-700';
        return 'bg-zinc-100 text-zinc-700';
    }

    private clearDetail() {
        this.application_id = '';
        this.application = null;
        this.company = null;
        this.program = null;
        this.modules = [];
        this.attendances = [];
        this.submissions = [];
        this.feedbacks = [];
        this.performances = [];
        this.posts = [];
        this.postsTotal = 0;
        this.selectedPost = null;
        this.milestones = [];
        this.selectedMilestone = null;
        this.alerts = [];
        this.unreadCount = 0;
    }

    private isSupportGroup(key: string): boolean {
        return ['ongoing', 'completed'].includes(key);
    }

    private todayString(): string {
        const d = new Date();
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    }

    private rowValue(row: any, key: string): any {
        if (!row) return '';
        if (row[key] !== undefined && row[key] !== null && row[key] !== '') return row[key];
        const programKey = `program_${key}`;
        if (row[programKey] !== undefined && row[programKey] !== null && row[programKey] !== '') return row[programKey];
        if (row.program && row.program[key] !== undefined && row.program[key] !== null && row.program[key] !== '') return row.program[key];
        if (row.id === this.application_id && this.program && this.program[key] !== undefined && this.program[key] !== null && this.program[key] !== '') return this.program[key];
        return '';
    }

    public isCompletedProgram(row: any): boolean {
        const status = String(row?.program_status || row?.program?.status || (row?.id === this.application_id ? this.program?.status : '') || '').toLowerCase();
        if (['completed', 'closed', 'canceled'].includes(status)) return true;
        const end = String(this.rowValue(row, 'end') || this.rowValue(row, 'program_end') || '').slice(0, 10);
        return !!end && end < this.todayString();
    }

    public groupForApplication(row: any): string {
        return this.isCompletedProgram(row) ? 'completed' : 'ongoing';
    }

    public visibleApplications(): any[] {
        const completed = this.supportGroup === 'completed';
        return (this.myApplications || []).filter((row: any) => this.isCompletedProgram(row) === completed);
    }

    public groupCount(key: string): number {
        const completed = key === 'completed';
        return (this.myApplications || []).filter((row: any) => this.isCompletedProgram(row) === completed).length;
    }

    public supportGroupLabel(): string {
        const found = this.supportGroups.find((g: any) => g.key === this.supportGroup);
        return found ? found.label : '지원사업';
    }

    public supportNavClass(key: string): string {
        if (this.supportGroup === key) {
            return 'flex items-center justify-between gap-2 rounded-lg bg-zinc-100 px-3 py-2 text-sm font-semibold text-zinc-900 transition-colors';
        }
        return 'flex items-center justify-between gap-2 rounded-lg px-3 py-2 text-sm font-medium text-zinc-500 hover:bg-zinc-50 hover:text-zinc-900 transition-colors';
    }

    public selectSupportGroup(key: string) {
        this.service.href(`/support/manage/${key}`);
    }

    public programTitle(row: any): string {
        return this.rowValue(row, 'title') || row?.program_title || row?.program_id || '지원사업';
    }

    public programCode(row: any): string {
        return this.rowValue(row, 'code') || row?.program_code || '';
    }

    public programCategory(row: any): string {
        return this.rowValue(row, 'category') || row?.program_category || '';
    }

    public programAgency(row: any): string {
        return row?.program_organizer || this.rowValue(row, 'agency') || row?.program_agency || '-';
    }

    public programHost(row: any): string {
        return row?.program_host || row?.host || row?.sponsor || '-';
    }

    public programPeriod(row: any): string {
        const start = this.rowValue(row, 'program_start');
        const end = this.rowValue(row, 'program_end');
        if (!start && !end) return '-';
        return `${start || '?'} ~ ${end || '?'}`;
    }

    public applyPeriod(row: any): string {
        const start = this.rowValue(row, 'apply_start');
        const end = this.rowValue(row, 'apply_end');
        if (!start && !end) return '';
        return `모집 ${start || '?'} ~ ${end || '?'}`;
    }

    public programStatusLabel(s: string): string {
        const m: any = {
            draft: '준비중', recruiting: '모집중', evaluating: '평가중',
            operating: '운영중', paused: '일시중지', completed: '완료',
            closed: '종료', canceled: '취소',
        };
        return m[s] || s || '-';
    }

    public programStatusColor(s: string): string {
        if (['operating', 'recruiting'].includes(s)) return 'bg-emerald-50 text-emerald-700';
        if (s === 'evaluating') return 'bg-amber-50 text-amber-700';
        if (['completed', 'closed'].includes(s)) return 'bg-zinc-100 text-zinc-700';
        if (s === 'canceled') return 'bg-red-50 text-red-700';
        return 'bg-zinc-100 text-zinc-600';
    }

    public selectMenu(k: string) { this.service.href(`/support/manage/${this.application_id}/${k}`); }
    public selectApp(aid: string) { this.service.href(`/support/manage/${aid}/overview`); }

    public formatMoney(n: any): string { return (Number(n) || 0).toLocaleString(); }

    public openSubmit() {
        this.submitForm = { module_id: '', session_id: '', submission_type: 'homework', title: '', content: '' };
        this.showSubmit = true;
    }
    public closeSubmit() { this.showSubmit = false; }
    public async submitSubmission() {
        if (!this.submitForm.title) {
            this.service.alert.show({ title: '입력', message: '제목을 입력하세요.', action: '확인' }); return;
        }
        const payload: any = { application_id: this.application_id, ...this.submitForm };
        const r = await wiz.call('submit_submission', payload);
        if (r.code != 200) {
            this.service.alert.show({ title: '실패', message: r.data?.message || '오류', action: '확인' }); return;
        }
        this.showSubmit = false;
        await this.loadTab();
    }

    public openPerf(p?: any) {
        if (p) {
            this.perfForm = { ...p };
        } else {
            const now = new Date();
            const period = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}`;
            this.perfForm = { report_period: period, revenue: 0, investment_raised: 0, new_hires: 0, new_patents: 0, awards: '', narrative: '' };
        }
        this.showPerf = true;
    }
    public closePerf() { this.showPerf = false; }
    public async submitPerf() {
        if (!this.perfForm.report_period) {
            this.service.alert.show({ title: '입력', message: '보고기간(YYYY-MM)을 입력하세요.', action: '확인' }); return;
        }
        const payload: any = {
            application_id: this.application_id,
            program_id: this.application?.program_id || '',
            ...this.perfForm,
        };
        const r = await wiz.call('upsert_performance', payload);
        if (r.code != 200) {
            this.service.alert.show({ title: '실패', message: r.data?.message || '오류', action: '확인' }); return;
        }
        this.showPerf = false;
        await this.loadTab();
    }

    public moduleIcon(t: string): string {
        const m: any = { mentoring: '🎓', education: '📚', ir: '💼', networking: '🤝', visit: '🏢', submission: '📄', evaluation: '⭐', etc: '📌' };
        return m[t] || '📌';
    }
    public moduleLabel(t: string): string {
        const m: any = { mentoring: '멘토링', education: '교육', ir: 'IR', networking: '네트워킹', visit: '방문', submission: '제출', evaluation: '평가', etc: '기타' };
        return m[t] || t;
    }

    public attendanceRate(): number {
        if (!this.attendances || this.attendances.length === 0) return 0;
        const att = this.attendances.filter(a => a.status === 'attended').length;
        return Math.round((att / this.attendances.length) * 100);
    }

    // ===== 기업정보 편집 =====
    public startEditCompany() {
        const a = this.application || {};
        this.companyForm = {
            company_name: a.company_name || '',
            registed_number: a.registed_number || '',
            ceo_name: a.ceo_name || '',
            ceo_email: a.ceo_email || '',
            ceo_phone: a.ceo_phone || '',
            business_area: a.business_area || '',
            employee_count: a.employee_count || 0,
            revenue: a.revenue || 0,
            summary: a.summary || '',
        };
        this.editingCompany = true;
    }

    public cancelEditCompany() {
        this.editingCompany = false;
        this.companyForm = {};
    }

    public async saveCompanyInfo() {
        const payload: any = { application_id: this.application_id, ...this.companyForm };
        const r = await wiz.call('update_my_application_info', payload);
        if (r.code != 200) {
            this.service.alert.show({ title: '저장 실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        this.application = r.data.data?.application;
        this.company = r.data.data?.company;
        this.program = r.data.data?.program;
        this.editingCompany = false;
        this.service.toast?.success?.('기업정보가 저장되었습니다.');
        await this.service.render();
    }

    // ===== 사업자등록증 =====
    public getBusinessLicense(): any {
        const att = this.application?.attachments;
        if (!Array.isArray(att)) return null;
        return att.find((a: any) => a && a.key === 'business_license') || null;
    }

    public licenseDownloadUrl(): string {
        const lic = this.getBusinessLicense();
        if (!lic) return '';
        const params = new URLSearchParams({
            application_id: this.application_id,
            stored_name: lic.stored_name,
            original_name: lic.original_name || lic.stored_name,
        });
        return `/wiz/api/page.support.manage/download_my_application_file?${params.toString()}`;
    }

    public async onLicenseFileChange(event: any) {
        const files = event?.target?.files;
        if (!files || files.length === 0) return;
        const file = files[0];
        const fd = new FormData();
        fd.append('application_id', this.application_id);
        fd.append('file', file);
        this.uploadingLicense = true;
        await this.service.render();
        try {
            const resp = await fetch('/wiz/api/page.support.manage/upload_business_license', {
                method: 'POST', body: fd, credentials: 'same-origin',
            });
            const json = await resp.json();
            if (resp.status !== 200) {
                this.service.alert.show({ title: '업로드 실패', message: json?.message || '오류', action: '확인' });
            } else {
                if (this.application) this.application.attachments = json.attachments || [];
                this.service.toast?.success?.('사업자등록증이 업로드되었습니다.');
            }
        } catch (e: any) {
            this.service.alert.show({ title: '업로드 실패', message: String(e), action: '확인' });
        }
        this.uploadingLicense = false;
        if (event?.target) event.target.value = '';
        await this.service.render();
    }

    public async removeBusinessLicense() {
        const lic = this.getBusinessLicense();
        if (!lic) return;
        if (!confirm('사업자등록증을 삭제하시겠습니까?')) return;
        const r = await wiz.call('remove_business_license', {
            application_id: this.application_id,
            stored_name: lic.stored_name,
        });
        if (r.code != 200) {
            this.service.alert.show({ title: '삭제 실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        if (this.application) this.application.attachments = r.data.attachments || [];
        await this.service.render();
    }
}

export default PageSupportManageComponent;